import type { FaireProductEntity } from "../../entity_types/product";

export const p_6n7xwjgwr3: FaireProductEntity = {
  token: "p_6n7xwjgwr3",
  type: "product",
  name: "Uganda Kisoro Estate Anaerobic Natural",
  brandToken: "b_8rgv5suw2a",
  brandName: "Portrait Coffee",
  imageUrl: "https://cdn.faire.com/fastly/25acd5c3c2f7912cce38437c272798e6217798025ed7dc868bde7ce325702be6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e2b211a43ad32c89492aacc6d74558a3a091cd573cee9ecef654fff7df3c0dac.jpeg",
    "https://cdn.faire.com/fastly/2cc82a436b593786422cc8904bb012d92eeaccce74a2df5ae78759a039f2119f.jpeg",
    "https://cdn.faire.com/fastly/39ac9ad37820f2bf5587e32d22ad54c824322df3b98796ffda25e0e8a2a36bee.jpeg"
  ],
  priceDollars: 15,
  description: "\n * Tasting Notes: cooked red grape, dried cranberry, brown sugar \n * Country: Uganda \n * Region: Western Region (Kisoro District) \n * Producer: Kenneth Barigye (Mountain Harvest) \n * Varietal: SL14, SL28, Nyasaland, Bugisu \n * Process: Anaerobic Natural ",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:38.020Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
